import { RouteItem } from '@eastcoal/router/types/route'

import { WITHDRAW_APPLY_LIST_PAGE_PATH } from './constants/path'
import { WITHDRAW_APPLY_LIST_PAGE_UUID } from './constants/uuid'

export const withdrawApplyRoute: RouteItem = {
  title: '提现审批',
  path: WITHDRAW_APPLY_LIST_PAGE_PATH,
  uuid: WITHDRAW_APPLY_LIST_PAGE_UUID,
  Component: () => import('./index')
}
